import { useNavigate } from 'react-router-dom'
import './Home.css'

const Home = () => {
  const navigate = useNavigate()

  return (
    <div className="home-container">
      <h1 className="home-title">FrogBox Multi-Sport Graphics</h1>
      <div className="home-subtitle-container">
        <p className="home-subtitle">Navigate your browser to</p>
        <pre>/:customerId/:eventGuid</pre>
        <p className="home-subtitle">to preview a match, or:</p>
      </div>
      <button className="home-button" onClick={() => navigate('/demo-customer/demo-event-guid')}>
        Demo Mode
      </button>
    </div>
  )
}

export default Home
